import { withRouter } from "react-router";
import { Component } from "react";
import { utils } from "../common/utils";

class ScrollToTop extends Component {
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            //window.scrollTo(0, 0)
            utils.scrollTop();
        }
    }


    render() {
        return this.props.children
    }
}

export default withRouter(ScrollToTop)